export const locationFromConfig = (): URL => {
  // @ts-expect-error
  if (window.BUGHERD_SIDEBAR_CONFIG?.proxySiteUrl) {
    // @ts-expect-error
    const proxySiteURL = new URL(window.BUGHERD_SIDEBAR_CONFIG.proxySiteUrl);
    const proxySiteDomain = proxySiteURL.origin;
    return new URL(`${proxySiteDomain}${window.location.pathname}`);
  } else if (
    'BugHerdConfig' in window &&
    typeof window.BugHerdConfig === 'object' &&
    'location' in window.BugHerdConfig
  ) {
    if (
      typeof window.BugHerdConfig.location === 'object' &&
      window.BugHerdConfig.location.origin &&
      window.BugHerdConfig.location.href
    ) {
      return window.BugHerdConfig.location;
    } else {
      console.error(
        `window.BugHerdConfig.location set to ${typeof window.BugHerdConfig
          .location}, but expected URL. Example: window.BugHerdConfig.location = new URL(${
          window.location.origin
        }/example)`
      );
    }
  }

  return new URL(window.location.href);
};
